<div class="content__inner">
    <header class="content__title">
        <h1>{{ "salesmanagerorders.list.title" | translate }}</h1>
        <small>{{ "salesmanagerorders.list.subtitle" | translate }}</small>
    </header>

    <div class="card" *appHasPermission="'SALESMANAGERORDERS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "salesmanagerorders.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="salesManager">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "salesmanagerorders.props.salesmanager" | translate }}</th>
                        <td mat-cell *matCellDef="let row" [innerHtml]="row.salesManager?.htmlFormatUser()"></td>
                    </ng-container>

                    <ng-container matColumnDef="distributor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "salesmanagerorders.props.distributor" | translate }}</th>
                        <td mat-cell *matCellDef="let row" [innerHtml]="row.distributor.htmlFormatUser()"></td>
                    </ng-container>

                    <ng-container matColumnDef="itemCount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "salesmanagerorders.props.itemcount" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.itemCount }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "salesmanagerorders.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date: UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <i (click)="viewOrder(row._id)" class="zmdi zmdi-eye zmdi-hc-fw tableIcon" *appHasPermission="'SALESMANAGERORDERS.READ'"></i>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
